module.exports = __webpack_public_path__ + "static/img/logoMain.6cffabc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logoMain.png
// module id = FfEr
// module chunks = 4